<template>
  <SourcingBoardView
    board-type="growth"
    storage-key="growthSourcingBoard"
    :description="description"
  />
</template>

<script>
// 로켓그로스 소싱관리 — 화면 본체는 분석 소싱관리와 같은 컴포넌트를 쓴다.
// SourcingBoard 컬렉션을 공유하므로 boardType='growth' 로 행을 갈라 서로 안 섞이게 한다.
//
// 이 보드는 **이미 정한 상품의 원가를 맞추는 작업대**다. 담기 경로가 없어(행을 직접 만들고
// 1688·쿠팡 링크로 채운다) 시장 지표가 안 실리므로 「점수」·「시장」 컬럼 그룹을 빼고 쓴다
// (SourcingBoardView 의 GROWTH_HIDDEN_COLS). "뭘 팔지 고르는" 일은 분석 소싱관리 쪽이다.
import SourcingBoardView from '@/components/common/SourcingBoardView'

export default {
  name: 'GrowthSourcingBoard',
  components: { SourcingBoardView },
  data () {
    return {
      description: '팔기로 정한 상품의 원가를 맞추는 작업대예요 · 1688 → 스펙 → 마진 → 확정 순서로 밀고, 매입가는 통합통관 기준으로 자동 계산돼요'
    }
  }
}
</script>
